import { render, staticRenderFns } from "./Wizard-Interest.vue?vue&type=template&id=33f64f72&scoped=true"
import script from "./Wizard-Interest.vue?vue&type=script&lang=js"
export * from "./Wizard-Interest.vue?vue&type=script&lang=js"
import style0 from "./Wizard-Interest.vue?vue&type=style&index=0&id=33f64f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f64f72",
  null
  
)

export default component.exports